import { useCallback, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { TextInput } from "react-native-paper";
import { useUpload } from "../../hooks/useUpload";
import { Image } from "react-native";
import { DropFile, NameFile } from "./style";
import { View } from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import { animated, useSpring } from "react-spring";
import { useCustomTheme } from "../../contexts/useCustomTheme";

export const UploadImages = ({ fileType, index }) => {
  const [files, setFiles] = useState([]);

  const {
    handleUpload,
    onDropRejectedMessage,
    IconStatus,
    loadExistingImage,
    existingImage,
    handleDeleteExistingImage,
    statusUpload,
  } = useUpload();

  useEffect(() => {
    loadExistingImage(fileType, index);
  }, [fileType]);

  const onDrop = useCallback(
    (acceptedFiles) => {
      handleUpload(acceptedFiles, fileType, setFiles, index);
    },
    [fileType, setFiles]
  );

  const dropzone = useDropzone({
    accept: { "image/png": [".png"] },
    maxSize: 2097152, // 2MB in bytes
    onDropRejected: onDropRejectedMessage,
    maxFiles: 1,
    onDrop,
    onFileDialogCancel: () => {
      setFiles([]); // Reset files state when file dialog is cancelled
    },
  });

  const { getRootProps, getInputProps } = useDropzone({
    accept: { "image/png": [".png"] },
    maxSize: 2 * 1024 * 1024,
    maxFiles: 1,
    onDrop,
    onDropRejected: onDropRejectedMessage,
    onFileDialogCancel: () => setFiles([]),
  });

  const rotateProps = useSpring({
    loop: true,
    from: { rotateZ: 0 },
    to: { rotateZ: 360 },
    config: { duration: 2000 },
  });
  const AnimatedView = animated(View);

  const { customInfo } = useCustomTheme();
  return (
    <DropFile
      {...getRootProps()}
      style={{
        borderRadius: 5,
      }}
    >
      <input
      {...getInputProps()}
      style={{ position: 'absolute', left: -9999, width: 0, height: 0, opacity: 0 }}
    />
      {existingImage ? (
        <>
          <View>
            {fileType.includes("font") ? (
              <NameFile>{existingImage}</NameFile>
            ) : (
              <Image
                source={{ uri: existingImage }}
                style={{
                  width: "48px",
                  maxWidth: "48px",
                  minHeight: "48px",
                  maxHeight: "48px",
                  objectFit: "cover",
                }}
              />
            )}
          </View>

          <AnimatedView
            style={
              statusUpload === "uploading"
                ? {
                    ...rotateProps,
                    position: "absolute",
                    top: "-6px",
                    right: "-6px",
                  }
                : { position: "absolute", top: "-6px", right: "-6px" }
            }
          >
            <FontAwesome
              name={
                statusUpload === "uploading" ? "circle-o-notch" : "times-circle"
              }
              size={24}
              color={statusUpload === "uploading" ? "#14181d" : "red"}
              onPress={() => handleDeleteExistingImage(fileType, index)}
            />
          </AnimatedView>
        </>
      ) : (
        <IconStatus />
      )}
    </DropFile>
  );
};
